// Vendor imports
const { Route, Switch } = require('react-router-dom')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Portal = require('client-v2/common/components/portal')
const withCommonRoot = require('client-v2/common/components/root')
const AuthModal = require('client-v2/common/containers/auth-modal-v2/component-smart')
const ConfirmModal = require('client-v2/common/containers/confirm-modal/component-smart')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoLinkModal = require('client-v2/into-landing/containers/link-modal/component-smart')
const IntoFooter = require('client-v2/into-landing/components/footer')
const SMSModal = require('client-v2/into-landing/containers/sms-modal/component-smart')
const ContentProfileLayout = require('client-v2/into-landing/pages/content-profile/component-smart')
const TopicProfileLayout = require('client-v2/into-landing/pages/topic-profile/component-smart')
const UserProfileLayout = require('client-v2/into-landing/pages/user-profile/component-smart')

const bem = BemEntity('IntoLandingLayout')

function IntoLandingLayout() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('content')
      },
        tag(Switch,
          tag(Route, {
            component: ContentProfileLayout,
            exact: true,
            path: '/!:hash'
          }),
          tag(Route, {
            component: TopicProfileLayout,
            exact: true,
            path: [
              '/topic/:key'
            ]
          }),
          tag(Route, {
            component: UserProfileLayout,
            exact: true,
            path: [
              '/:username',
              '/:username/posts'
            ]
          })
        )
      ),
      tag(IntoLinkModal, {
        className: bem.element('link-modal')
      }),
      tag(IntoFooter, {
        className: bem.element('footer')
      }),
      Portal.toModalRoot(
        tag(AuthModal),
        tag(SMSModal),
        tag(ConfirmModal)
      )
    )
  )
}

const wrappedComponent = withCommonRoot(IntoLandingLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  IntoLandingLayout
})
